<mat-sidenav-container autosize>
  <mat-sidenav #sidemenu
      [opened]="sideMenuOpened"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="0"
      id="sideMenu"
      appResizable>
    <mat-nav-list dense>      
      <app-sidenav-menu (closeMenu)="sidemenu.close()"></app-sidenav-menu>

      <mat-menu #settingsMenu="matMenu" xPosition="before">
          <mat-list>
              <mat-list-item>
                <mat-checkbox
                  [(ngModel)]="showPopularRecipients"
                  (change)="savePopularRecipients()"
                  (click)="$event.stopPropagation()"
                > Show popular recipients </mat-checkbox>
              </mat-list-item>
              <mat-list-item>
                <mat-form-field>
                  <mat-label> Avatars </mat-label>
                  <mat-select
                    [(ngModel)]="avatarSource"
                    (click)="$event.stopPropagation()"
                    (selectionChange)="saveAvatarSource()"
                  >
                    <mat-option [value]="AvatarSource.REMOTE"> Load from external services </mat-option>
                    <mat-option [value]="AvatarSource.LOCAL">  Only from Contacts </mat-option>
                    <mat-option [value]="AvatarSource.NONE">   Disabled </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-list-item>
          </mat-list>
      </mat-menu>

      <div style="display: flex;">
        <div id="sidenavGreeting">
            <p>Good {{timeOfDay}}, {{(rmmapi.me | async)?.user_address}}.</p>
            <p id="sidenavGreetingContent"><a routerLink="/welcome" class="textLink">Welcome</a> to Runbox 7! Please see <a href="https://help.runbox.com/runbox-7-webmail-new-features/" target="help" class="textLink">help</a> and our <a href="https://community.runbox.com/" target="forum" class="textLink">forum</a> for support and suggestions.</p>
            <p *ngIf="experimentalFeatureEnabled">
                <a routerLink="/onscreen" class="textLink"> (Experimental) create a video call </a>
            </p>
            <p *ngIf="!((rmmapi.me | async)?.is_alternative_email_validated)">
              <span style="color:red">Please confirm your Alternative Email address.</span>
              <a class="textLink" routerLink="/account/details"> Visit the Account Details page to resend the email</a>
            </p>
        </div>
        <div>
            <button mat-icon-button [matMenuTriggerFor]="settingsMenu" id="webmailSettingsMenuButton" matTooltip="Show webmail settings">
                <mat-icon svgIcon="cog"></mat-icon>
            </button>
        </div>
      </div>

      <mat-divider></mat-divider>


      <mat-divider></mat-divider>

      <div class="sidenavSubMenu" *ngIf="mobileQuery.matches">
        <a mat-button (click)="compose();" matTooltip="Compose">
          <mat-icon  svgIcon="pencil" color="primary"></mat-icon></a>
        <a mat-button (click)="drafts();" matTooltip="Drafts">
          <mat-icon svgIcon="email-open" color="primary"></mat-icon></a>
      </div>

      <button mat-list-item (click)="compose();" id="composeButton" [ngClass]="{'selectedFolder' : composeSelected}">
        <mat-icon mat-list-icon  svgIcon="pencil" class="folderIconStandard"></mat-icon>
        Compose
      </button>

      <button mat-list-item (click)="drafts()" id="draftsButton" [ngClass]="{'selectedFolder' : draftsSelected}">
        <mat-icon mat-list-icon  svgIcon="email-open" class="folderIconStandard"></mat-icon>
        <p mat-line class="folderName">Drafts</p>
        <span style="flex-grow: 1"></span>
        <span class="foldersidebarcount" style="margin-right: 24px"> {{ draftDeskService.draftModels.value.length }} </span>
      </button>

      <button mat-list-item (click)="overview()" id="overviewButton" [ngClass]="{'selectedFolder' : overviewSelected}"
        *ngIf="searchService.localSearchActivated"
      >
        <mat-icon mat-list-icon svgIcon="blur" class="folderIconStandard"></mat-icon>
        <p mat-line class="folderName">Overview</p>
      </button>

      <mat-divider></mat-divider>
    </mat-nav-list>

    <app-popular-recipients
        [ngStyle]="{ 'display': this.showPopularRecipients ? 'block' : 'none' }"
        (recipientClicked)="searchFor($event)"
    >
        <mat-list-item *ngIf="!searchService.localSearchActivated" (click)="downloadIndexFromServer()">
            Synchronize index in order to use this feature
        </mat-list-item>
    </app-popular-recipients>

    <mat-divider></mat-divider>

    <app-saved-searches (searchClicked)="searchFor($event)"></app-saved-searches>

    <mat-divider></mat-divider>

    <rmm-folderlist #folderListComponent
        [folders]="displayedFolders"
        [folderMessageCounts]="messagelistservice.folderMessageCountSubject"
        [selectedFolder]="selectedFolder"
        (folderSelected)="selectFolder($event)"
        (droppedToFolder)="dropToFolder($event)"
        (emptyTrash)="emptyTrash($event)"
        (emptySpam)="emptySpam($event)"
        (createFolder)="createFolder($event)"
        (deleteFolder)="deleteFolder($event)"
        (moveFolder)="moveFolder($event)"
        (renameFolder)="renameFolder($event)"
    ></rmm-folderlist>

    <mat-divider></mat-divider>

    <mat-nav-list *ngIf="searchService.localSearchActivated">
      <button mat-list-item
        (click)="deleteLocalIndex()"
        matTooltip="Stop synchronization and remove index stored on your device">
          <mat-icon  svgIcon="sync-off" mat-list-icon></mat-icon>
          Stop index synchronization
      </button>
    </mat-nav-list>

    <mat-nav-list *ngIf="(xapianLoaded | async) && !searchService.localSearchActivated && searchService.downloadProgress === null && !offerInitialLocalIndex">
      <button mat-list-item (click)="downloadIndexFromServer()" matTooltip="Synchronize index with your device">
        <mat-icon matListIcon svgIcon="sync"></mat-icon>
        Synchronize index
      </button>
    </mat-nav-list>

    <mat-nav-list>
      <button mat-list-item (click)="composeBugReport()" matTooltip="Compose an email to runbox support">
        <mat-icon matListIcon svgIcon="spider"></mat-icon>
        Compose a bug report
      </button>
      <button *ngIf="showNotificationButton" mat-list-item (click)="enableNotification()">
        <mat-icon matListIcon svgIcon="bell"></mat-icon>
        Enable Notifications
      </button>
    </mat-nav-list>

    <mat-divider></mat-divider>

    <p style="text-align: center; font-size: 12px">
        Runbox 7 build time: {{buildtimestampstring}} <br>
        <a routerLink="/changelog"> Read the changelog </a>
        <ng-container *ngIf="updateService.updateIsReady | async">
          <br><span>An update of the application is available, and you may reload the app now to use the latest version.</span>
          <br>
          <button mat-raised-button (click)="reload()" color="primary">
            Reload app
          </button>
        </ng-container>
    </p>
  </mat-sidenav>
  <mat-sidenav *ngIf="mailViewerOnRightSide" position="end" mode="side"
    [opened]="!hasChildRouterOutlet
              && (singlemailviewer.messageId
                  || (!mobileQuery.matches && keepMessagePaneOpen)
            )"
    [style.width]="mailViewerRightSideWidth"
    id="rightPane"
    appResizable>
      <single-mail-viewer #singlemailviewer
      [messageActionsHandler]="messageActionsHandler"
      [adjustableHeight]="false"
      (afterLoadMessage)="updateMessageListHeight()"
      (orientationChangeRequest)="mailViewerOrientationChangeRequest($event)"
      (onClose)="singleMailViewerClosed($event)"></single-mail-viewer>
      <div *ngIf="mailViewerOnRightSide && !singlemailviewer.messageId"
	   class="noMessageSelectedNotification">
	    <div>
          <h3 class="noMessageSelectedNotification">No Message Selected</h3>
          <button mat-raised-button (click)="dontShowMessagePane()" color="primary">
            Keep preview pane closed unless a message is opened
          </button>
          <p>
            You can also change this setting from the display menu<br />
	        at the top right of the message list.
          </p>
	    </div>
      </div>
  </mat-sidenav>
  <div id="mailMenuContainer">
    <mat-toolbar id="mailMenu" style="display: flex">
      <button mat-icon-button (click)="sidemenu.toggle();" matTooltip="Toggle folder pane" id="toggleFolderPaneIcon">
	    <mat-icon svgIcon="menu"></mat-icon>
      </button>
      
      <ng-container *ngIf="!hasChildRouterOutlet">
        <div id="offerLocalIndex" *ngIf="offerInitialLocalIndex; else searchBar">
          <p *ngIf="!mobileQuery.matches">
            Runbox <span *ngIf="searchService.downloadProgress===null">will now synchronize</span><span *ngIf="searchService.downloadProgress!==null">is now synchronizing</span> with your device to give you an optimal webmail experience. The data can be deleted at any time using the buttons beneath the folder list. <a href="https://help.runbox.com/runbox-7-webmail-new-features/#Synchronized_account_index" target="help">What's this?</a>
          </p>
          <p *ngIf="mobileQuery.matches">
            Runbox will now synchronize with your device. <a href="https://help.runbox.com/runbox-7-webmail-new-features/#Synchronized_account_index" target="help" matTooltip="What's this?">?</a>
          </p>
          <mat-list>
            <mat-list-item>
              <button mat-raised-button (click)="downloadIndexFromServer()" matTooltip="Synchronize index with your device" color="primary" [disabled]="searchService.indexDownloadingInProgress">OK!</button>
              <button mat-raised-button (click)="cancelOrRefuseLocalIndex()" matTooltip="{{ searchService.indexDownloadingInProgress ? 'Cancel Download' : 'Do not synchronize index'}}" data-cy="cancel-button" color="warn">Cancel</button>
            </mat-list-item>
          </mat-list>
        </div>
        <ng-template #searchBar>
          <mat-form-field id="searchField" floatLabel="auto"
                          *ngIf="searchService.downloadProgress===null">
            <input matInput #searchInputField type="text"
                   (focus)="searchTextFieldFocus()"
                   (blur)="searchTextFieldBlur()" [placeholder]="dynamicSearchFieldPlaceHolder ? dynamicSearchFieldPlaceHolder: 'Start typing to search messages'"
                   [value]="searchText" (keyup)="searchFor($event.target.value)" matTooltip="Enter one or more search terms, or click the wrench to display the advanced search pane" />
            <!-- <app-search-expression-builder
                 [searchInputField]="searchInputField"
                 [currentFolder]="selectedFolder"
                 matSuffix matTooltip="Show search options"></app-search-expression-builder> -->
            <button *ngIf="searchText!==''"
                    mat-icon-button
                    matSuffix
                    (click)="showSaveSearchDialog()"
                    matTooltip="Save search">
              <mat-icon svgIcon="content-save"></mat-icon>
            </button>
            <button *ngIf="!showMultipleSearchFields"
                    mat-icon-button
                    matSuffix
                    (click)="showMultipleSearchFields = true"
                    matTooltip="Show advanced search pane">
              <mat-icon svgIcon="wrench"></mat-icon>
            </button>
            <button *ngIf="searchText!==''"
                    mat-icon-button
                    matSuffix
                    (click)="searchFor('')"
                    matTooltip="Clear search">
              <mat-icon svgIcon="close"></mat-icon>
            </button>
          </mat-form-field>
        </ng-template>
	    
        <button mat-icon-button (click)="updateViewMode('conversations')" *ngIf="!searchtextfieldfocused && viewmode==='singleconversation'"
                matTooltip="Back to conversations list">
          <mat-icon svgIcon="arrow-left"></mat-icon>
        </button>
        
	    <!-- Message action menu for regular screens -->
	    <div *ngIf="!mobileQuery.matches && !hasChildRouterOutlet && showSelectOperations" class="messageListActionButtonsRight" #toolbarListButtonContainer>
	      <button *ngIf="morelistbuttonindex>0" mat-icon-button matTooltip="Move selected message(s) to folder" (click)="moveToFolder()">
            <mat-icon svgIcon="folder"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>1" mat-icon-button (click)="deleteMessages()"
		          [matTooltip]="selectedFolder !== this.messagelistservice.trashFolderName ? 'Move selected message(s) to Trash' : 'Delete permanently'"
		          >
            <mat-icon
              *ngIf="selectedFolder !== this.messagelistservice.trashFolderName; else deletePermanently"
              svgIcon="delete"
              >
            </mat-icon>
            <ng-template #deletePermanently>
              <mat-icon svgIcon="delete-forever"></mat-icon>
            </ng-template>
	      </button>
	      <button *ngIf="morelistbuttonindex>2" mat-icon-button matTooltip="Mark unread" (click)="setReadStatus(false)">
	        <mat-icon svgIcon="email-mark-as-unread"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>3" mat-icon-button matTooltip="Mark read" (click)="setReadStatus(true)">
            <mat-icon svgIcon="email-open"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>4" mat-icon-button matTooltip="Set flag" (click)="setFlaggedStatus(true)">
            <mat-icon svgIcon="flag"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>5" mat-icon-button matTooltip="Unset flag" (click)="setFlaggedStatus(false)">
            <mat-icon svgIcon="flag-outline"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>6 && selectedFolder!==messagelistservice.spamFolderName" mat-icon-button matTooltip="Report selected message(s) as spam" (click)="trainSpam({is_spam:1})">
            <mat-icon svgIcon="alert-octagon"></mat-icon>
	      </button>
	      <button *ngIf="morelistbuttonindex>6 && selectedFolder===messagelistservice.spamFolderName" mat-icon-button matTooltip="Report selected message(s) as not spam" (click)="trainSpam({is_spam:0})">
            <mat-icon svgIcon="alert-octagon-outline"></mat-icon>
	      </button>
          <button *ngIf="morelistbuttonindex < 7" [matMenuTriggerFor]="moreMailListActionsMenu" mat-icon-button matTooltip="More message actions">
            <mat-icon svgIcon="dots-vertical"></mat-icon>
          </button>
          
          <!-- Message action overflow items for regular screens -->
          <mat-menu #moreMailListActionsMenu="matMenu">
	        <button *ngIf="morelistbuttonindex<1" mat-menu-item (click)="moveToFolder()">
              <mat-icon svgIcon="folder"></mat-icon>
              <span>Move to folder...</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<2" mat-menu-item (click)="deleteMessages()">
              <mat-icon
                *ngIf="selectedFolder !== this.messagelistservice.trashFolderName; else deletePermanently"
                svgIcon="delete"
                >
              </mat-icon>
              <ng-template #deletePermanently>
                <mat-icon svgIcon="delete-forever"></mat-icon>
              </ng-template>
              <span>{{selectedFolder !== this.messagelistservice.trashFolderName ? 'Move to Trash' : 'Delete permanently'}}</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<3" mat-menu-item (click)="setReadStatus(false)">
	          <mat-icon svgIcon="email-mark-as-unread"></mat-icon>
              <span>Mark unread</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<4" mat-menu-item (click)="setReadStatus(true)">
              <mat-icon svgIcon="email-open"></mat-icon>
              <span>Mark read</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<5" mat-menu-item (click)="setFlaggedStatus(true)">
              <mat-icon svgIcon="flag"></mat-icon>
              <span>Set flag</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<6" mat-menu-item (click)="setFlaggedStatus(false)">
              <mat-icon svgIcon="flag-outline"></mat-icon>
              <span>Unset flag</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<7 && selectedFolder!==messagelistservice.spamFolderName" mat-menu-item (click)="trainSpam({is_spam:1})">
              <mat-icon svgIcon="alert-octagon"></mat-icon>
              <span>Report as spam</span>
	        </button>
	        <button *ngIf="morelistbuttonindex<8 && selectedFolder===messagelistservice.spamFolderName" mat-menu-item (click)="trainSpam({is_spam:0})">
              <mat-icon svgIcon="alert-octagon-outline"></mat-icon>
              <span>Report as not spam</span>
	        </button>
          </mat-menu>
	    </div>
        
        <mat-menu #tableViewOptionsMenu="matMenu">
          <mat-list>
            <mat-list-item>
              <mat-checkbox
                *ngIf="canvastable"
                [(ngModel)]="canvastable.showContentTextPreview"
                matLine
                (change)="saveContentPreviewSetting()"
                (click)="$event.stopPropagation()"
                class="tableViewOptionsMenuElement"
                >
                <mat-icon  svgIcon="view-list" class="tableViewOptionsMenuElement" matTooltip="Inline message previews"></mat-icon>
                Inline previews
              </mat-checkbox>
            </mat-list-item>
            <!-- currently only supporting threading for local index -->
            <mat-list-item>
              <mat-checkbox [(ngModel)]="conversationGroupingCheckbox"
                            matLine
                            (change)="updateViewMode($event.source.checked ? 'conversations' : 'messages')"
                            (click)="$event.stopPropagation()"
                            [disabled]="unreadMessagesOnlyCheckbox || !showingSearchResults"
                            class="tableViewOptionsMenuElement"
                            >
                <mat-icon  svgIcon="format-align-right" class="tableViewOptionsMenuElement" [matTooltip]="conversationGroupingToolTip"></mat-icon>
                Threaded view
              </mat-checkbox>
            </mat-list-item>
            <mat-list-item>
              <mat-checkbox [(ngModel)]="unreadMessagesOnlyCheckbox"
                            matLine
                            (change)="updateSearch(true)"
                            (click)="$event.stopPropagation()"
                            [disabled]="viewmode==='conversations'"
                            class="tableViewOptionsMenuElement"
                            >
                <mat-icon  svgIcon="email-open" class="tableViewOptionsMenuElement" [matTooltip]="unreadOnlyToolTip"></mat-icon>
                Unread only
              </mat-checkbox>
            </mat-list-item>
            
            <mat-list-item *ngIf="!mobileQuery.matches">
              <mat-checkbox [(ngModel)]="keepMessagePaneOpen"
                            matLine
                            (change)="saveMessagePaneSetting()"
                            (click)="$event.stopPropagation()"
                            >
                <mat-icon  svgIcon="book-open" class="tableViewOptionsMenuElement" matTooltip="Keep preview pane open"></mat-icon>
                Keep preview pane open
              </mat-checkbox>
            </mat-list-item>
          </mat-list>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="tableViewOptionsMenu" matTooltip="Show view options">
          <mat-icon svgIcon="view-dashboard"></mat-icon>
        </button>
      </ng-container>
    </mat-toolbar>
    <mat-progress-bar *ngIf="searchService.downloadProgress!==null"
                      [mode]="searchService.downloadProgress===0 ? 'indeterminate' : 'determinate'"
                      [value]="searchService.downloadProgress">
    </mat-progress-bar>

    <mat-progress-bar *ngIf="websocketsearchservice.searchInProgress" mode="indeterminate">
    </mat-progress-bar>

    <mat-progress-bar
      *ngIf="searchService.partitionDownloadProgress!==null && searchService.partitionDownloadProgress!==1"
      [value]="searchService.partitionDownloadProgress*100">
    </mat-progress-bar>

	<app-multiple-search-fields-input
          *ngIf="showMultipleSearchFields && searchService.downloadProgress===null"
          [currentFolder]="selectedFolder"
          (close)="showMultipleSearchFields = false"
          (searchexpression)="searchFor($event)">
        </app-multiple-search-fields-input>

	<div [hidden]="hasChildRouterOutlet">
      <div id="canvasTableContainerArea" [ngStyle]="{'bottom.px': canvasTableBtmOffset}">
        <canvastablecontainer [canvastableselectlistener]="this" (sortToggled)="updateSearch(true)"></canvastablecontainer>
      </div>

      <single-mail-viewer #singlemailviewer *ngIf="!mailViewerOnRightSide"
          [adjustableHeight]="true"
          [showVerticalSplitButton]="allowMailViewerOrientationChange"
          [messageActionsHandler]="messageActionsHandler"
          (afterLoadMessage)="updateMessageListHeight()"
          (orientationChangeRequest)="mailViewerOrientationChangeRequest($event)"
          (onClose)="singleMailViewerClosed($event)"></single-mail-viewer>
    </div>
  </div>

  <!-- Message action floating menu for mobile screens -->
  <div class="contextToolButtonsMobile" *ngIf="mobileQuery.matches && !hasChildRouterOutlet && showSelectOperations && !showSelectMarkOpMenu">
    <button mat-fab matTooltip="Move&nbsp;to&nbsp;folder" matTooltipPosition="left" (click)="moveToFolder()">
      <mat-icon svgIcon="folder"></mat-icon>
    </button>
    <button mat-fab (click)="deleteMessages()"
            [matTooltip]="selectedFolder !== this.messagelistservice.trashFolderName ? 'Move to Trash' : 'Delete permanently'"
            matTooltipPosition="left"
	    >
      <mat-icon
        *ngIf="selectedFolder !== this.messagelistservice.trashFolderName; else deletePermanently"
        svgIcon="delete"
        >
      </mat-icon>
      <ng-template #deletePermanently>
        <mat-icon svgIcon="delete-forever"></mat-icon>
      </ng-template>
    </button>
    <button mat-fab matTooltip="Mark as ..." matTooltipPosition="left" (click)="openMarkOpMenu()">
      <mat-icon svgIcon="playlist-check"></mat-icon>
    </button>
    <button *ngIf="selectedFolder!==messagelistservice.spamFolderName" mat-fab matTooltip="Report spam" matTooltipPosition="left" (click)="trainSpam({is_spam:1})">
      <mat-icon svgIcon="alert-octagon"></mat-icon>
    </button>
    <button mat-fab *ngIf="selectedFolder===messagelistservice.spamFolderName" matTooltip="Not spam" matTooltipPosition="left" (click)="trainSpam({is_spam:0})">
      <mat-icon svgIcon="alert-octagon-outline"></mat-icon>
    </button>
  </div>
  
  <!-- Message action floating submenu for mobile screens -->
  <div class="contextToolButtonsMobile" *ngIf="mobileQuery.matches && !hasChildRouterOutlet && showSelectOperations && showSelectMarkOpMenu">
    <button mat-fab matTooltip="Mark unread" matTooltipPosition="left" (click)="setReadStatus(false)">
      <mat-icon svgIcon="email-mark-as-unread"></mat-icon>
    </button>
    <button mat-fab matTooltip="Mark read" matTooltipPosition="left" (click)="setReadStatus(true)">
      <mat-icon svgIcon="email-open"></mat-icon>
    </button>
    <button mat-fab matTooltip="Set flag" matTooltipPosition="left" (click)="setFlaggedStatus(true)">
      <mat-icon svgIcon="flag"></mat-icon>
    </button>
    <button mat-fab matTooltip="Unset flag" matTooltipPosition="left" (click)="setFlaggedStatus(false)">
      <mat-icon svgIcon="flag-outline"></mat-icon>
    </button>
    <button mat-fab matTooltip="Back" matTooltipPosition="left" (click)="closeMarkOpMenu()">
      <mat-icon svgIcon="keyboard-backspace"></mat-icon>
    </button>
  </div>
  <router-outlet (activate)="childRouteActivated(true)" (deactivate)="childRouteActivated(false)"></router-outlet>
</mat-sidenav-container>

<!-- This will cause an error in dev mode with the async pipe, should not be present however in production -->
<div style="position: absolute; bottom: 2px; right: 2px; z-index: 10000;"
    *ngIf="progressService.httpRequestInProgress | async"
    >
  <mat-spinner diameter="20" ></mat-spinner>
</div>
